module.exports = __webpack_public_path__ + "img/2_1.cb019b2e.png";